export const auctionData = [
    {
        propertyId: "BARB081320200001",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "TONK",
        reservePrice: 4104000,
        emd: 410400,
        emdLastDate: "NA",
        city: "KAKOD, UNIYARA",
        borrowerName: "BABA MOTORS",
        ownerName: "MOHAN LAL CHOPDAR",
        ownershipType: "FREEHOLD",
        summaryDescription: "VILLAGE - KAKOD, TEHSIL- UNIYARA, DISTRICT - TONK",
        propertyType: "RESIDENTIAL",
        propertySubType: "INDIVIDUAL HOUSE",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI SYMBOLIC",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "PATTA NO. 22, NATIONAL HIGHWAY 116, TONK ROAD, VILLAGE - KAKOD, TEHSIL - UNIYARA, DISTRICT - TONK",
        nearestTransport: "CHOUTH KA BARWADA",
        authorisedOfficer: {
            name: "Moazzam Masood",
            contact: "9099924584"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BARB081320200001/TERMS_AND_CONDITIONS_FOR_SALE_-_Portated.pdf"
    },


    {
        propertyId: "BARB097920210015",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "PALI",
        reservePrice: 4362660,
        emd: 436200,
        emdLastDate: "NA",
        city: "PALI",
        borrowerName: "Rishabh Prints",
        ownerName: "Ashok Transport Company",
        ownershipType: "FREEHOLD",
        summaryDescription: "Shop 43 Transport Nagar, Pali",
        propertyType: "COMMERCIAL",
        propertySubType: "SHOPS",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI SYMBOLIC",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "Shop 43 Transport Nagar, Pali",
        nearestTransport: "Pali",
        authorisedOfficer: {
            name: "Meena Jagdish Prasad",
            contact: "8875001916"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BARB097920210015/rishbh.pdf"
    },

    {
        propertyId: "BARB097920210016",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "PALI",
        reservePrice: 3851550,
        emd: 385155,
        emdLastDate: "NA",
        city: "PALI",
        borrowerName: "Rishabh Prints",
        ownerName: "Kaushlaya Devi",
        ownershipType: "FREEHOLD",
        summaryDescription: "Shop No 45 Transport Nagar, Pali",
        propertyType: "COMMERCIAL",
        propertySubType: "SHOPS",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI SYMBOLIC",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "Shop No 45 Transport Nagar, Pali",
        nearestTransport: "Pali",
        authorisedOfficer: {
            name: "Meena Jagdish Prasad",
            contact: "8875001916"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BARB097920210016/rishbh.pdf"
    },

    {
        propertyId: "BARB097920210017",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "PALI",
        reservePrice: 8152000,
        emd: 815200,
        emdLastDate: "NA",
        city: "PALI",
        borrowerName: "K S Tex J J Feb Tex",
        ownerName: "Rajan Kawad",
        ownershipType: "FREEHOLD",
        summaryDescription: "Plot No 48, Tilak Nagar, Pali",
        propertyType: "COMMERCIAL",
        propertySubType: "PLOT COMMERCIAL",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI SYMBOLIC",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "Plot No 48, Tilak Nagar, Pali",
        nearestTransport: "Pali",
        authorisedOfficer: {
            name: "Meena Jagdish Prasad",
            contact: "8875001916"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BARB097920210017/Scan_24_Feb_2022.pdf"
    },

    {
        propertyId: "BARB097920210018",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "PALI",
        reservePrice: 10179000,
        emd: 1017900,
        emdLastDate: "NA",
        city: "PALI",
        borrowerName: "Deepak Textile",
        ownerName: "Shri Kishan Arora",
        ownershipType: "FREEHOLD",
        summaryDescription: "House No 5, Mahaveer Nagar, Pali",
        propertyType: "RESIDENTIAL",
        propertySubType: "INDIVIDUAL HOUSE",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI SYMBOLIC",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "House No 5, Mahaveer Nagar, Pali",
        nearestTransport: "Pali",
        authorisedOfficer: {
            name: "Meena Jagdish Prasad",
            contact: "8875001916"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BARB097920210018/deepak.pdf"
    },
    {
        propertyId: "BARB097920210019",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "PALI",
        reservePrice: 5889803,
        emd: 588980,
        emdLastDate: "NA",
        city: "PALI",
        borrowerName: "Suresh Gehlot",
        ownerName: "Suresh Gehlot",
        ownershipType: "FREEHOLD",
        summaryDescription: "Plot No 36 K No 1381 Adinath Colony, Pali",
        propertyType: "RESIDENTIAL",
        propertySubType: "INDIVIDUAL HOUSE",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI SYMBOLIC",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "Plot No 36 K No 1381 Adinath Colony, Pali",
        nearestTransport: "Pali",
        authorisedOfficer: {
            name: "Meena Jagdish Prasad",
            contact: "8875001916"
        },
        pdfUrl: "http://ibapi.in/upload_saleinfo/BARB097920210019/suresh.pdf"
    },
    
    {
        propertyId: "BARB097920220014",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "PALI",
        reservePrice: 3800000,
        emd: 380000,
        emdLastDate: "NA",
        city: "PALI",
        borrowerName: "Rishabh Prints",
        ownerName: "Ashok Kumar Joshi",
        ownershipType: "FREEHOLD",
        summaryDescription: "",
        propertyType: "COMMERCIAL",
        propertySubType: "SHOPS",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI SYMBOLIC",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "Shop No 42, Situated at Transport Nagar, Pali",
        nearestTransport: "Pali",
        authorisedOfficer: {
            name: "Meena Jagdish Prasad",
            contact: "8875001916"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BARB097920220014/rishbh.pdf"
    }
    ,
    {
        propertyId: "BARB0KOOKAS1",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "JAIPUR",
        reservePrice: 726000,
        emd: 72600,
        emdLastDate: "NA",
        city: "VILLAGE: CHHAPARADI, TEH AMER",
        borrowerName: "Bharat Lal Shiv Dayal",
        ownerName: "Shiv Dayal Sharma",
        ownershipType: "LEASEHOLD",
        summaryDescription: "Total Area 150 Sq. Yard",
        propertyType: "RESIDENTIAL",
        propertySubType: "INDIVIDUAL HOUSE",
        typeOfTitleDeed: "REGISTERED LEASE DEED",
        statusOfPossession: "SARFAESI SYMBOLIC",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "House Patta No 558, Village and Post Chhaparadi, Teh Amer, Dist Jaipur",
        nearestTransport: "Jaipur",
        authorisedOfficer: {
            name: "Subodh D Inamdar",
            contact: "9358400870"
        },
        pdfUrl: "http://ibapi.in/upload_saleinfo/BARB0KOOKAS1/TERMS_AND_CONDITIONS_compressed_(3).pdf"
    }
    ,
    {
        propertyId: "BARB0SFSMAN4",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "JAIPUR",
        reservePrice: 6121000,
        emd: 612100,
        emdLastDate: "NA",
        city: "JAIPUR",
        borrowerName: "V S Textile",
        ownerName: "Vinod Gupta S/O Hari Lal Gupta",
        ownershipType: "LEASEHOLD",
        summaryDescription: "Plot No 31/241, Pratap Nagar, Sanganer, Jaipur",
        propertyType: "RESIDENTIAL",
        propertySubType: "INDIVIDUAL HOUSE",
        typeOfTitleDeed: "CONVEYANCE DEED",
        statusOfPossession: "SARFAESI PHYSICAL",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "Plot No 31/241, Pratap Nagar, Sanganer, Jaipur",
        nearestTransport: "Sanganer",
        authorisedOfficer: {
            name: "Virendra Kasliwal",
            contact: "9460006051"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BARB0SFSMAN4/04.05.2022.pdf"
    },
    {
        propertyId: "BARB0STAJAI2",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "JAIPUR",
        reservePrice: 6100000,
        emd: 610000,
        emdLastDate: "NA",
        city: "SANGANER",
        borrowerName: "Mr. Satish Chand",
        ownerName: "Satish Chand",
        ownershipType: "LEASEHOLD",
        summaryDescription: "House No 75/268, Pratap Nagar, Sanganer, Jaipur 302029, 90 Sq Mtr",
        propertyType: "RESIDENTIAL",
        propertySubType: "INDIVIDUAL HOUSE",
        typeOfTitleDeed: "REGISTERED LEASE DEED",
        statusOfPossession: "SARFAESI SYMBOLIC",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "House No 75/268, Pratap Nagar, Sanganer, Jaipur 302029, 90 Sq Mtr",
        nearestTransport: "Sanganer",
        authorisedOfficer: {
            name: "Mukesh Kumar Jain",
            contact: "9694352023"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BARB0STAJAI2/TERMS_AND_CONDITIONS_compressed.pdf"
    },

    {
        propertyId: "BARB259920210042",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "HANUMANGARH",
        reservePrice: 1900000,
        emd: 190000,
        emdLastDate: "NA",
        city: "Sangaria, Hanumangarh, Rajasthan",
        borrowerName: "R K IMPEX",
        ownerName: "Uma Devi W/o Prem Nath",
        ownershipType: "FREEHOLD",
        summaryDescription: "Residential house no. 101/3 west part, south facing, ward no. 15, Nr. Rishi Ashram Chowk, Sangaria, Dist. Hanumangarh, Rajasthan Adm 900 sq. feet",
        propertyType: "RESIDENTIAL",
        propertySubType: "INDIVIDUAL HOUSE",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI SYMBOLIC",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "Sangaria, Hanumangarh, Rajasthan",
        nearestTransport: "NA",
        authorisedOfficer: {
            name: "Rohit Vora",
            contact: "7878489797"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BARB259920210042/For_more_details.pdf"
    },

    {
        propertyId: "BARB263920200018",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "SIROHI",
        reservePrice: 9925000,
        emd: 993000,
        emdLastDate: "NA",
        city: "ABU ROAD",
        borrowerName: "Ms Shiv Jyoti Furnace Pvt. Ltd",
        ownerName: "Ms Shiv Jyoti Furnace Pvt. Ltd",
        ownershipType: "LEASEHOLD",
        summaryDescription: "INDUSTRIAL PROPERTY Admeasuring 4056.80 Sq. Mtr",
        propertyType: "INDUSTRIAL",
        propertySubType: "INDUSTRIAL SHED",
        typeOfTitleDeed: "REGISTERED LEASE DEED",
        statusOfPossession: "SARFAESI PHYSICAL",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "Plot No. E-29, Growth Centre Phase –II, RIICO, Abu Road, Dist- Sirohi, Admeasuring 4056.80 Sq. Mtr",
        nearestTransport: "NA",
        authorisedOfficer: {
            name: "PUMLIENSANG GANGTE",
            contact: "9711908984"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BARB263920200018/Auction_06.07.2020._(1).pdf"
    },
    
    {
        propertyId: "BARB301920200003",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "AJMER",
        reservePrice: "NA",
        emd: 50701,
        emdLastDate: "NA",
        city: "ARADHANA NAGAR AJMER",
        borrowerName: "Kalu Das Son of Poosa Das",
        ownerName: "Kalu Das Son of Poosa Das",
        ownershipType: "LEASEHOLD",
        summaryDescription: "",
        propertyType: "RESIDENTIAL",
        propertySubType: "PLOT RESIDENTIAL",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI PHYSICAL",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "P. N. 25 PART OF KHASRA NO 2102 VILL-KAYAD BHERON KHEJARA PUSHKAR BYE PASS ARADHANA NAGAR",
        nearestTransport: "ajmer",
        authorisedOfficer: {
            name: "RAM SINGH NAIN",
            contact: "9414752329"
        },
        pdfUrl: ""
    },

    {
        propertyId: "BARB537620200001",
        bankName: "BANK OF BARODA",
        branchName: "",
        state: "RAJASTHAN",
        district: "BHILWARA",
        reservePrice: 472500,
        emd: 47250,
        emdLastDate: "NA",
        city: "Kaniya village, hurda tahsil",
        borrowerName: "MUBARIK HUSAIN SO MIRABAKSH",
        ownerName: "MADINA WO MUBARIK HUSAIN",
        ownershipType: "LEASEHOLD",
        summaryDescription: "patta no 16, 161 sq yards",
        propertyType: "RESIDENTIAL",
        propertySubType: "INDIVIDUAL HOUSE",
        typeOfTitleDeed: "REGISTERED LEASE DEED",
        statusOfPossession: "SARFAESI PHYSICAL",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "patta no 16, book no 9, village kaniya, tahsil hurda dist bhilwara",
        nearestTransport: "",
        authorisedOfficer: {
            name: "RAM SINGH NAIN",
            contact: "9414752329"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BARB537620200001/BARAL_SALE_NOTICE.pdf"
    },


    {
        propertyId: "BKIDSARM059",
        bankName: "BANK OF INDIA",
        branchName: "",
        state: "RAJASTHAN",
        district: "JAIPUR",
        reservePrice: "NA",
        emd: 280000,
        emdLastDate: "NA",
        city: "JAGATPURA ROAD, JAIPUR",
        borrowerName: "V.R.PROCUREMENT CORPORATION PVT.LTD.",
        ownerName: "V.R.PROCUREMENT CORPORATION PVT.LTD.",
        ownershipType: "FREEHOLD",
        summaryDescription: "UNIT NO. LGF-04, AREA 471 SQ.FT. SUPER BUILT UP",
        propertyType: "COMMERCIAL",
        propertySubType: "SHOPS",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI PHYSICAL",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "LOWER GROUND FLOOR, GOLD SOUK AT PLOT NO.02, JAGATPURA ROAD, JAIPUR",
        nearestTransport: "NEAR JAWAHAR CIRCLE",
        authorisedOfficer: {
            name: "Avanendra Kr Singh",
            contact: "9934041801"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BKIDSARM059/Paper_upper.pdf"
    },

    {
        propertyId: "BKIDSARM060",
        bankName: "BANK OF INDIA",
        branchName: "",
        state: "RAJASTHAN",
        district: "JAIPUR",
        reservePrice: "NA",
        emd: 270000,
        emdLastDate: "NA",
        city: "JAGATPURA ROAD, JAIPUR",
        borrowerName: "V.R.PROCUREMENT CORPORATION PVT.LTD.",
        ownerName: "V.R.PROCUREMENT CORPORATION PVT.LTD.",
        ownershipType: "FREEHOLD",
        summaryDescription: "UNIT NO. LGF-05, AREA 467 SQ.FT. SUPER BUILT UP",
        propertyType: "COMMERCIAL",
        propertySubType: "SHOPS",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI PHYSICAL",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "LOWER GROUND FLOOR, GOLD SOUK AT PLOT NO.02, JAGATPURA ROAD, JAIPUR",
        nearestTransport: "NEAR JAWAHAR CIRCLE",
        authorisedOfficer: {
            name: "Avanendra Kr Singh",
            contact: "9934041801"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BKIDSARM060/Paper_upper.pdf"
    },
    
    {
        propertyId: "BKIDSARM061",
        bankName: "BANK OF INDIA",
        branchName: "",
        state: "RAJASTHAN",
        district: "JAIPUR",
        reservePrice: "NA",
        emd: 280000,
        emdLastDate: "NA",
        city: "JAGATPURA ROAD, JAIPUR",
        borrowerName: "V.R.PROCUREMENT CORPORATION PVT.LTD.",
        ownerName: "V.R.PROCUREMENT CORPORATION PVT.LTD.",
        ownershipType: "FREEHOLD",
        summaryDescription: "UNIT NO. LGF-06, AREA 474 SQ.FT. SUPER BUILT UP",
        propertyType: "COMMERCIAL",
        propertySubType: "SHOPS",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI PHYSICAL",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "LOWER GROUND FLOOR, GOLD SOUK AT PLOT NO.02, JAGATPURA ROAD, JAIPUR",
        nearestTransport: "NEAR JAWAHAR CIRCLE",
        authorisedOfficer: {
            name: "Avanendra Kr Singh",
            contact: "9934041801"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BKIDSARM061/Paper_upper.pdf"
    },
    
    {
        propertyId: "BKIDSARM062",
        bankName: "BANK OF INDIA",
        branchName: "",
        state: "RAJASTHAN",
        district: "JAIPUR",
        reservePrice: "NA",
        emd: 260000,
        emdLastDate: "NA",
        city: "JAGATPURA ROAD, JAIPUR",
        borrowerName: "V.R.PROCUREMENT CORPORATION PVT.LTD.",
        ownerName: "V.R.PROCUREMENT CORPORATION PVT.LTD.",
        ownershipType: "FREEHOLD",
        summaryDescription: "UNIT NO. LGF-07, AREA 441 SQ.FT. SUPER BUILT UP",
        propertyType: "COMMERCIAL",
        propertySubType: "SHOPS",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI PHYSICAL",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "LOWER GROUND FLOOR, GOLD SOUK AT PLOT NO.02, JAGATPURA ROAD, JAIPUR",
        nearestTransport: "NEAR JAWAHAR CIRCLE",
        authorisedOfficer: {
            name: "Avanendra Kr Singh",
            contact: "9934041801"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BKIDSARM062/Paper_upper.pdf"
    },

    {
        propertyId: "BKIDSARM063",
        bankName: "BANK OF INDIA",
        branchName: "",
        state: "RAJASTHAN",
        district: "JAIPUR",
        reservePrice: "NA",
        emd: 270000,
        emdLastDate: "NA",
        city: "JAGATPURA ROAD, JAIPUR",
        borrowerName: "V.R.PROCUREMENT CORPORATION PVT.LTD.",
        ownerName: "V.R.PROCUREMENT CORPORATION PVT.LTD.",
        ownershipType: "FREEHOLD",
        summaryDescription: "UNIT NO. LGF-08, AREA 440 SQ.FT. SUPER BUILT UP",
        propertyType: "COMMERCIAL",
        propertySubType: "SHOPS",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI PHYSICAL",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "LOWER GROUND FLOOR, GOLD SOUK AT PLOT NO.02, JAGATPURA ROAD, JAIPUR",
        nearestTransport: "NEAR JAWAHAR CIRCLE",
        authorisedOfficer: {
            name: "Avanendra Kr Singh",
            contact: "9934041801"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BKIDSARM063/Paper_upper.pdf"
    },
    
    {
        propertyId: "BKIDSARM064",
        bankName: "BANK OF INDIA",
        branchName: "",
        state: "RAJASTHAN",
        district: "JAIPUR",
        reservePrice: "NA",
        emd: 280000,
        emdLastDate: "NA",
        city: "JAGATPURA ROAD, JAIPUR",
        borrowerName: "V.R.PROCUREMENT CORPORATION PVT.LTD.",
        ownerName: "V.R.PROCUREMENT CORPORATION PVT.LTD.",
        ownershipType: "FREEHOLD",
        summaryDescription: "UNIT NO. LGF-09, AREA 469 SQ.FT. SUPER BUILT UP",
        propertyType: "COMMERCIAL",
        propertySubType: "SHOPS",
        typeOfTitleDeed: "REGISTERED SALE DEED",
        statusOfPossession: "SARFAESI PHYSICAL",
        auctionOpenDate: "NA",
        auctionCloseDate: "NA",
        sealedBidLastDate: "NA",
        sealedBidExtendedDate: "NA",
        address: "LOWER GROUND FLOOR, GOLD SOUK AT PLOT NO.02, JAGATPURA ROAD, JAIPUR",
        nearestTransport: "NEAR JAWAHAR CIRCLE",
        authorisedOfficer: {
            name: "Avanendra Kr Singh",
            contact: "9934041801"
        },
        pdfUrl: "https://ibapi.in/upload_saleinfo/BKIDSARM064/Paper_upper.pdf"
    },
    
    
    
    
    
];
